import React, { Fragment, useState } from "react";
import { Checkbox, Button, message, Divider } from "antd";
import moment from "moment";

const Card2 = (props) => {
  const { cardData, selectedMenuItemId, handleUpdateCartItem } = props;

  const [selectedItems, setSelectedItems] = useState(new Set());

  const dispatchOrRejectItems = (action) => {
    const payload =
      action === "dispatch"
        ? {
            is_dispatched: true,
          }
        : { is_rejected: true };
    selectedItems.forEach((itemId) => {
      try {
        handleUpdateCartItem(itemId, payload);
      } catch (error) {
        message.error(error.message);
      }
    });
  };

  const handleCheckboxChange = (checked, item) => {
    if (checked) {
      setSelectedItems((currentVal) => {
        const updatedSet = new Set(currentVal).add(item.id);
        return updatedSet;
      });
    } else {
      setSelectedItems((currentVal) => {
        const updatedSet = new Set(currentVal);
        updatedSet.delete(item.id);
        return updatedSet;
      });
    }
  };

  const firstOrder = cardData[cardData.length - 1];

  const shouldHighlight = cardData.some(
    (card) => card.menu_item.id === selectedMenuItemId
  );

  if (!cardData.length) {
    return null;
  }

  const [itemsToBeServed, servedItems] = cardData.reduce(
    ([_itemsToBeServed, _servedItems], item) => {
      if (item.is_dispatched) {
        return [_itemsToBeServed, [..._servedItems, item]];
      }
      return [[..._itemsToBeServed, item], _itemsToBeServed];
    },
    [[], []]
  );

  return (
    <div
      className="expo_card"
      style={{
        opacity: selectedMenuItemId ? (shouldHighlight ? 1 : 0.5) : 1,
      }}
    >
      <div className="head_title complete">
        <div>{moment(firstOrder.updated_at).fromNow()}</div>
      </div>
      <div className="card_content">
        {itemsToBeServed.map((item, idx) => (
          <div className="content_item" key={item.id}>
            <div className="content_rowtext">
              <div>{item.quantity}</div>
              <div className="cross">x</div>
              <div className="item_name">
                <div className="name_row">
                  <div className="text-left">{item.menu_item.name}</div>
                  <div>
                    <Checkbox
                      size="small"
                      onChange={(e) =>
                        handleCheckboxChange(e.target.checked, item)
                      }
                      checked={selectedItems.has(item.id)}
                    />
                  </div>
                </div>
                <p className="item_info">Note: --</p>
              </div>
            </div>
          </div>
        ))}
        {itemsToBeServed.length && servedItems.length ? (
            <Divider />
        ) : null}
        {servedItems.length > 0 && <h5 className="font-normal text-left px-2">Items Served</h5>}
        {servedItems.map((item, idx) => (
          <Fragment key={item.id}>
            <div className="content_item" key={item.id}>
              <div className="content_rowtext">
                <div className="line-through">{item.quantity}</div>
                <div className="cross">x</div>
                <div className="item_name">
                  <div className="name_row">
                    <div className="line-through text-left">{item.menu_item.name}</div>
                    <span className="served-label">Served</span>
                  </div>
                </div>
              </div>
            </div>
          </Fragment>
        ))}
        <div className="footer_btn mb-1">
          <Button
            type="primary"
            danger
            ghost
            className="reject_btn"
            disabled={!selectedItems.size}
            onClick={() => dispatchOrRejectItems("reject")}
          >
            Reject
          </Button>
          <Button
            type="primary"
            className="dispatch_btn"
            disabled={!selectedItems.size}
            onClick={() => dispatchOrRejectItems("dispatch")}
          >
            {cardData.length && cardData[0].order_type === "POS"
              ? "Send to Table"
              : "Dispatch"}
          </Button>
        </div>
      </div>
    </div>
  );
};
export default Card2;
